import { useState } from "react";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";
import ToastHelper from "@/utils/toastHelper";
import apiClient from "@/services/apiClient";
import { COMPANY } from "@/data/mockData";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await apiClient.post("/contact", { ...f, subject: "Website contact request" });
      ToastHelper.success(response.data?.message || "Message sent! We'll reply within 1 business hour.");
      setF({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      ToastHelper.apiError(error, "Unable to send your message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div>
      <section className="bg-[#0A2540] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm font-semibold tracking-wide uppercase text-orange-400 mb-3">Contact</div>
          <h1 className="text-4xl lg:text-5xl font-display font-extrabold">Get in touch with our team</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 py-16 grid lg:grid-cols-[1fr_1.2fr] gap-10">
        <div className="space-y-5">
          <div className="wc-card"><div className="flex items-center gap-3 mb-1"><Phone className="w-5 h-5 text-orange-500" /><div className="font-display font-extrabold text-[#0A2540]">Call us</div></div><div className="text-slate-600">{COMPANY.phone}</div></div>
          <div className="wc-card"><div className="flex items-center gap-3 mb-1"><Mail className="w-5 h-5 text-orange-500" /><div className="font-display font-extrabold text-[#0A2540]">Email</div></div><div className="text-slate-600">{COMPANY.email}</div></div>
          <div className="wc-card">
  <div className="flex items-center gap-3 mb-1">
    <MapPin className="w-5 h-5 text-orange-500" />
    <div className="font-display font-extrabold text-[#0A2540]">
      Head Office
    </div>
  </div>
  <div className="text-slate-600">
    4/70 Main Street, Pakenham VIC, 3810
  </div>
</div>

          <div className="wc-card"><div className="flex items-center gap-3 mb-1"><Clock className="w-5 h-5 text-orange-500" /><div className="font-display font-extrabold text-[#0A2540]">Hours</div></div><div className="text-slate-600">Mon-Fri: 8:30am - 5pm</div></div>
        </div>

        <form onSubmit={submit} className="wc-card p-8" data-testid="contact-page-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="wc-label">Name</label><input required className="wc-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="cp-name" /></div>
            <div><label className="wc-label">Phone</label><input className="wc-input" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="cp-phone" /></div>
          </div>
          <div className="mt-4"><label className="wc-label">Email</label><input required type="email" className="wc-input" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="cp-email" /></div>
          <div className="mt-4"><label className="wc-label">Message</label><textarea required rows={6} className="wc-input resize-none" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="cp-message" /></div>
          <button type="submit" disabled={submitting} className="mt-5 wc-btn-primary w-full justify-center" data-testid="cp-submit"><Send className="w-4 h-4" />{submitting ? "Sending..." : "Send message"}</button>
        </form>
      </section>
    </div>
  );
}
